/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import {
    Table, TableBody, TableCell, TableContainer,
    FormControlLabel, Switch,
    TableHead, TableRow, Button, TextField, Box
} from '@mui/material';
import { Image, Space, Row, Col } from "antd";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import customStyles from "../../../../../assets/styles/customStyles";
import { partyGSTHead } from "../../../../../config/constant";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import clsx from "clsx";
import { NavLink } from "react-router-dom";
import { toast } from 'react-toastify';
import usePrevious from "../../../../Shared/components/Previous";
import { useDispatch, useSelector } from "react-redux";
import crudActions from "../../../../CRUD/redux/actions";
import { customAlaphaNumericOnlyValidation } from "../../../../../helpers/validation";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { checkCRUDPermission, getColumnWidth } from "../../../../../helpers/utilities";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";


export const PartyGstCodeTable = (props) => {
    const { onRequestSort, sortOrder, sortBy, details, productGstdetails, loadTasks, loadMore, loadMoreContent, loadMoreTask, roleManagement } = props;
    const [visible, setVisible] = useState(false);
    const { editDetails, editError, editLoader } = useSelector(state => state.crudReducer);
    const [gstId, setGstId] = useState('');
    const [code, setCode] = useState('');
    const [description, setDescription] = useState('');
    const [additionalText, setAdditionalText] = useState('');
    const [sez, setSez] = useState(false);
    const [errorCode, setErrorCode] = useState('');
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const [productGst, setProductGst] = useState([]);
    const [productGstId, setProductGstId] = useState([]);
    const [isProductGstNew, setIsProductGstNew] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);

    const dispatch = useDispatch();

    const onEdit = (data) => {
        emptyStateInput();
        setVisible(true);
        setGstId(data.id);
        setCode(data.code);
        setDescription(data.description);
        setAdditionalText(data.additionalText);
        setSez(data.isSEZ ? true : false);
        var filtered = [];
        var filterIds = [];
        for (var arr in data.productGsts) {
            for (var filter in productGstdetails) {
                if (data.productGsts[arr].id === productGstdetails[filter].id) {
                    filtered.push(data.productGsts[arr]);
                    filterIds.push(data.productGsts[arr].id);
                }
            }
        }
        setProductGst(filtered);
        setProductGstId(filterIds);
    }

    const emptyState = () => {
        setErrorCode(false);
    };

    const emptyStateInput = () => {
        setCode('');
        setDescription('');
        setIsProductGstNew(false);
        setProductGst([]);
        setProductGstId([]);
    };

    const editGst = (e) => {
        e.preventDefault();
        let emptyGst = customAlaphaNumericOnlyValidation('Gst Code', code);
        emptyState();
        if (emptyGst.isValid) {
            dispatch({
                type: crudActions.EDIT_DETAILS_START,
                url: 'partygst',
                id: gstId,
                title: 'Party Gst',
                details: {
                    code: code,
                    description: description,
                    productGsts: productGstId,
                    additionalText: additionalText,
                    isSEZ: sez,
                }
            });
        } else {
            if (emptyGst.errors) {
                setErrorCode(emptyGst.errors);
            }
        }
    }

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            loadTasks();
            toast.dismiss();
            toast(editDetails);
            setVisible(false);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let error = editError.error.message.split("|");
            if (error[0] === 'code') {
                setErrorCode(error[1]);
            }
        }
    }, [editDetails, editError]);

    const handleClose = () => {
        setVisible(false);
        emptyStateInput();
        emptyState();
    };


    const handleDeleteModal = (value) => {
        setDeleteModal(value);
    }

    const onDelete = (data) => {
        setDeleteModal(true);
        setGstId(data.id);
        setCode(data.code);
    };


    const selectProductGst = (value) => {
        if (value !== '') {
            let p = productGstdetails.filter((el) => { return el.id === value });
            let newArr = productGst.concat(p);
            let newArrId = productGstId.concat(value);
            setProductGst(newArr);
            setProductGstId(newArrId);

        }
    };

    const deleteProductGst = (value) => {
        let p = productGst.filter((el) => { return el.id !== value });
        let pId = productGstId.filter((el) => { return el !== value });
        setProductGst(p);
        setProductGstId(pId);
    }

    const classes = customStyles();
    return (
        <>
            <CustomInfiniteScroll
                loadMore={loadMore}
                loadMoreContent={loadMoreContent}
                heads={partyGSTHead}
                onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                sortOrder={sortOrder}
                sortBy={sortBy}
                loadMoreTask={() => loadMoreTask()}
                component={
                    <>
                        {
                            !loadMore || details === '' ? (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={partyGSTHead.length}><div className={classes.loadMoreCircle}></div></TableCell>
                                </TableRow>
                            ) : (
                                <React.Fragment>
                                    {
                                        details && Array.isArray(details) && details?.length > 0 ? details?.map((data, i) => (
                                            <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell style={{ width: getColumnWidth(partyGSTHead, 0) }}><span style={{ width: getColumnWidth(partyGSTHead, 0) }}>{data.code}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(partyGSTHead, 1) }}><span style={{ width: getColumnWidth(partyGSTHead, 1) }} className={classes.descEllipsis}>{data.description ? data.description : '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(partyGSTHead, 2) }}><span style={{ width: getColumnWidth(partyGSTHead, 3) }} className={classes.descEllipsis}>{data?.additionalText || '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(partyGSTHead, 3) }}><span style={{ width: getColumnWidth(partyGSTHead, 3) }}>{data?.isSEZ ? 'Yes' : 'No'}</span></TableCell>
                                                <TableCell>
                                                    <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Party GST Code', 'edit', 'Younote Admin') &&
                                                            <NavLink to={"#"} onClick={() => onEdit(data)}>
                                                                <Image
                                                                    src={EditIcon}
                                                                    preview={false}
                                                                />
                                                            </NavLink>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Party GST Code', 'deletable', 'Younote Admin') &&
                                                            <NavLink to={"#"} onClick={() => onDelete(data)} >
                                                                <Image
                                                                    src={DeleteIcon}
                                                                    preview={false}
                                                                />
                                                            </NavLink>
                                                        }
                                                    </Space>
                                                </TableCell>
                                            </TableRow>
                                        )) : (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                                <TableCell className={classes.textAlignCenter} colSpan={partyGSTHead.length}>
                                                    <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'Start Creating Party GST Code'}</p>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }

                    </>
                }
            />
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                width={'550px'}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={'Edit Party GST Code'}
                className={clsx(classes.closeBackGround, classes.width100P)}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => editGst(e)}>
                        <div className={classes.customFormFlexRemoveOverflow}>
                            <div className={classes.customFormFlex}>
                                <TextField autoComplete='one-time-code'
                                    label={["Party GST Code ", <span key={"Party GST Code"} className={classes.colorRedRequired}> *</span>]}
                                    variant={'standard'}
                                    value={code}
                                    error={errorCode ? true : false}
                                    helperText={errorCode}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => setCode(e.target.value)}
                                />
                                <TextField autoComplete='one-time-code'
                                    label='Description'
                                    variant={'standard'}
                                    value={description}
                                    className={clsx(classes.margin30t)}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}

                                    onChange={(e) => setDescription(e.target.value)}
                                />
                                <TextField autoComplete='one-time-code'
                                    label='Additional Text'
                                    variant={'standard'}
                                    value={additionalText}
                                    className={clsx(classes.margin30t)}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => setAdditionalText(e.target.value)}
                                />
                                <FormControlLabel
                                    classes={{
                                        label: clsx(classes.fonSize13, classes.noWrap, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink'), // Pass your override css here
                                    }}
                                    control={<Switch size='small' className={clsx(classes.customSwitch)}
                                        onChange={(e) => setSez(!sez)}
                                    />}
                                    label="SEZ"
                                    labelPlacement="top"
                                    checked={sez ? true : false}
                                    className={clsx(classes.marginLeft0, classes.margin20t, classes.flexStart)}
                                />
                            </div>
                            <div>
                                <div className={clsx(classes.PrimaryCard2)}> Link Product GST Code</div>
                                <Row className={clsx(classes.PrimaryCard2RowAlign)}>
                                    <Col className={classes.textAlignRight}>
                                        <Space>
                                            <NavLink
                                                to={'#'}
                                                className={clsx(classes.customLink)}
                                                onClick={(e) => setIsProductGstNew(true)}
                                            >
                                                <Image
                                                    src={AddIcon}
                                                    preview={false}
                                                    className={clsx(classes.antImage)}
                                                /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Link Product GST Code</span>
                                            </NavLink>
                                        </Space>
                                    </Col>
                                </Row>
                                <TableContainer className={classes.partyGstFormTable}>
                                    <Table sx={{ minWidth: '495px' }}>
                                        <TableHead>
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell>{'Product GST Code'}</TableCell>
                                                <TableCell sx={{ width: '65px' }}>{'Percentage'}</TableCell>
                                                <TableCell sx={{ width: '45px' }}>{'Actions'}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                productGst && productGst?.length > 0 && productGst?.map((data, i) => (
                                                    <TableRow key={i}>
                                                        <TableCell>{data.code}</TableCell>
                                                        <TableCell>{`${data.percentage}%`}</TableCell>
                                                        <TableCell className={classes.textAlignRight}>
                                                            <Image
                                                                src={DeleteIcon}
                                                                preview={false}
                                                                className={classes.cursor}
                                                                onClick={(e) => deleteProductGst(data.id)}
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                            }

                                            {
                                                productGst && productGst?.length === 0 && (
                                                    <TableRow>
                                                        <TableCell colSpan="3">
                                                            <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'Start Creating Product GST'}</p>
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            }

                                            {
                                                isProductGstNew && (
                                                    <TableRow>
                                                        <TableCell>
                                                            <AutoCompleteComponent
                                                                name={["Select"]}
                                                                heads={[{ 'key': 'code', 'name': 'Name' }]}
                                                                details={productGstdetails?.filter((el) => { return productGstId.every(e => parseInt(e) !== parseInt(el.id)) })}
                                                                parentValue={[]}
                                                                onChange={(data) => selectProductGst(data.id)}
                                                                //parentError={error?.defaultCustomerId}
                                                                position={"top"}
                                                            />
                                                        </TableCell>
                                                        <TableCell></TableCell>
                                                        <TableCell className={classes.textAlignRight}>
                                                            <Space>
                                                                <Image
                                                                    src={DeleteIcon}
                                                                    preview={false}
                                                                    className={classes.cursor}
                                                                    onClick={(e) => setIsProductGstNew(false)}
                                                                />
                                                            </Space>
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            <Button
                                key="save"
                                type='submit'
                                color='primary'
                                variant="contained"
                                className={clsx(classes.modalBtn, { [classes.loading]: editLoader })}>
                                Update & Close
                            </Button>
                        </div>
                    </Box>
                }
            />
            <DeleteModal onClose={(v) => handleDeleteModal(v)} id={gstId} loadTasks={() => loadTasks()} name={code} url={'partygst'} title={'Party gst'} visible={deleteModal} />
        </>
    )
}